module.exports = {"230822103":"驼腰子镇","230822104":"石头河子镇","230822106":"桦南镇","230822107":"土龙山镇","230822108":"孟家岗镇","230822109":"闫家镇","230822110":"柳毛河镇","230822205":"金沙乡","230822213":"梨树乡","230822214":"明义乡","230822215":"大八浪乡","230822216":"五道岗乡","230822400":"桦南林业局","230822480":"黑龙江桦南经济开发区","230822500":"曙光农场","230822580":"桦南种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230822.json
// module id = 859
// module chunks = 0